// Compatibility shim: definitions now live in src/Config/*, split by concern.
import { apiEndpoints } from "../Config/apiEndpoints";

// Loosely typed here (unlike the new `apiEndpoints`) so old dynamic-key
// call sites keep compiling as before.
export const urlEnum: any = apiEndpoints;

export { localUrlEnum } from "../Config/navigation";

export {
  documentsTypeEnum,
  sellTypeOrReserve,
  vehiclesExcelFields,
} from "../Config/vehicleDomain";
